import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Chart } from 'primereact/chart';
import { FiBarChart2 } from 'react-icons/fi';
import { motion } from 'framer-motion';


const TestReport = () => {
    const navigate = useNavigate();

    // ✅ Static mock data
    const topicData = [
        { topic: 'Algebra', total: 10, correct: 7, incorrect: 3, accuracy: 70 },
        { topic: 'Geometry', total: 8, correct: 4, incorrect: 4, accuracy: 50 },
        { topic: 'Trigonometry', total: 6, correct: 5, incorrect: 1, accuracy: 83 },
        { topic: 'Probability', total: 5, correct: 3, incorrect: 2, accuracy: 60 },
        { topic: 'Statistics', total: 7, correct: 7, incorrect: 0, accuracy: 100 },
    ];

    const chartData = {
        labels: topicData.map((d) => d.topic),
        datasets: [
            {
                label: 'Correct',
                backgroundColor: '#4caf50',
                data: topicData.map((d) => d.correct),
            },
            {
                label: 'Incorrect',
                backgroundColor: '#f44336',
                data: topicData.map((d) => d.incorrect),
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        plugins: {
            legend: { position: 'top' },
        },
    };

    return (
        <Box p={3}>
            <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: 'easeOut' }}
            >
                <Box mt={1} >
                <Button variant="contained" color="primary" onClick={() => navigate(-1)}>
                     Back
                </Button>
            </Box>
                <Typography variant="h4" mb={3} fontWeight="bold"
                    sx={{
                        textAlign: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1,
                        background: 'linear-gradient(90deg, #007bff, #00d4ff)',
                        // background: linear-gradient(90deg, #007bff, #00d4ff),
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                    }}>
                    <FiBarChart2 size={28} color='#007bff'/>
                    Test Report - Mathematics
                </Typography>
            </motion.div>

            {/* ✅ Topic-wise Table */}
            <Typography variant="h6" mb={2}>
                Topic-wise Performance Table
            </Typography>
            <div className="card" style={{ marginBottom: '2rem' }}>
                <DataTable value={topicData} paginator rows={5} responsiveLayout="scroll">
                    <Column field="topic" header="Topic" sortable />
                    <Column field="total" header="Total" sortable />
                    <Column field="correct" header="Correct" sortable />
                    <Column field="incorrect" header="Incorrect" sortable />
                    <Column field="accuracy" header="Accuracy (%)" sortable />
                </DataTable>
            </div>

            {/* ✅ Performance Bar Chart */}
            <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
            >
                <Typography
                    variant="h5"
                    fontWeight="bold"
                    sx={{
                        textAlign: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1,
                        // background: 'linear-gradient(90deg, #f57c00, #ffb74d, #ffe082)',
                        background: 'linear-gradient(90deg, #007bff, #00d4ff)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                    }}
                    mb={2}
                >
                    <FiBarChart2 size={24} color="#007bff" />
                    Performance Chart
                </Typography>
            </motion.div>
            <div className="card" style={{ marginBottom: '2rem', width: '100%', maxWidth: '100%' }}>
                <Chart type="bar" data={chartData} options={chartOptions} style={{width: '100%'}} />
            </div>

            {/* ✅ Recommendations */}
            <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.3 }}
            >
                <Typography
                    variant="h6"
                    fontWeight="bold"
                    sx={{
                        textAlign: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1,
                        // background: 'linear-gradient(90deg, #f57c00, #ffb74d, #ffe082)',
                        background: 'linear-gradient(90deg, #007bff, #00d4ff)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                    }}
                    mb={2}
                >
                    💡 Recommendations
                </Typography>
            </motion.div>
            <Box display="flex" flexDirection="column" gap={1} alignItems="center" mt={2}>
                {topicData.filter((t) => t.accuracy < 70).length === 0 ? (
                    <Box
                        sx={{
                            background: 'linear-gradient(90deg, #a5d6a7, #c8e6c9)',
                            color: '#2e7d32',
                            px: 2,
                            py: 1,
                            borderRadius: 2,
                            fontWeight: 500,
                        }}
                    >
                        🎉 Great job! You performed well in all topics.
                    </Box>
                ) : (
                    topicData
                        .filter((t) => t.accuracy < 70)
                        .map((t, i) => (
                            <Box
                                key={i}
                                sx={{
                                    // background: 'linear-gradient(90deg, #ffe082, #ffcc80)',
                                     background: 'linear-gradient(90deg, #007bff, #00d4ff)',
                                    // color: '#df3f0eff',
                                    color:'#fff',
                                    py: 1,
                                    borderRadius: 2,
                                    fontWeight: 500,
                                    width: 'fit-content',
                                    padding: '15px'
                                }}
                            >
                                ⚠️ Practice more on <strong>{t.topic}</strong> (Accuracy: {t.accuracy}%)
                            </Box>
                        ))
                )}
            </Box>


            
        </Box>
    );
};

export default TestReport;
